<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"
        />

         <input-text
            label="* Button Anchor Text"
            name="button_anchor_text"
            v-model="form.button_anchor_text"
            :error="errors.button_anchor_text ? errors.button_anchor_text[0] : null"
            :maxlength=255
        />

        <div
            class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 mb-4">* Category</p>
            <reference
                create-text="Create new category and link category to this page"
                link-text="Link an existing category"
                :two-step-create="true"
                :creatable="false"
                :language="form.language"
                v-model="form.category"
                model-data="All Category"
                :query="{
                    status_id: 1
                }"
                :order="{
                    'categories.name': 'asc'
                }"
                :error="errors.category_id ? errors.category_id[0] : null"
            />
        </div>

        <media-reference
            v-model="form.icon"
            class="mt-3"
            label="* Icon"
            :media-types="['Icon']"
            name="icon_id"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
export default {
    name: "PassionForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                button_anchor_text: this.getFormData("button_anchor_text"),
                category_id: this.getFormData("category_id"),
                category: this.getFormData("category"),
                icon_id: this.getFormData("icon_id"),
                icon: this.getFormData("icon"),
            },
        };
    },
    watch: {
        "form.icon": function(newValue){
            this.form.icon_id = newValue?.id || null;
        },
        "form.category": function(newValue){
            this.form.category_id = newValue?.id || null;
        },

    }
}
</script>
